import React, {useContext, useEffect} from 'react';
import {BRANDS, IS_SERVER} from "../../common";
import {setCookie} from "../../helpers";
import {promoOptions} from "../../utils/customRedirects";
import {brandContext} from "../../store/brandContext";

const CustomRedirect = ({landingTemplate}) => {
  const { lang, landingName } = landingTemplate.props;
  const brandName = useContext(brandContext);
  const promoDeadline = promoOptions[landingName].deadline;
  const startTimeRedirect = Date.parse(promoDeadline);
  const now = new Date().getTime();
  const redirect = now >= startTimeRedirect;
  const openAfterDeadline = window.location.search !== '?ThxVadim'

  const langIds = {
    'en': 2,
    'ru': 1
  }

  const langId = langIds[lang];

  useEffect(() => {

    if (redirect && openAfterDeadline )
    {
      if (!IS_SERVER) window.location.pathname = `/${brandName === BRANDS.zenbet ? `${lang}/` : ''}${window.location.search}`;
      setCookie('lang', langId)
    }
  }, []);

  return (
    <>
      {((redirect && openAfterDeadline))
        ? <></>
        : landingTemplate
      }
    </>
  );
}

export default CustomRedirect;